/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespShippingReturns_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailShipping_user" | "PdpSharedBuyerProtectionBox_user">;
    readonly " $refType": "PdpRespShippingReturns_user";
};
export type PdpRespShippingReturns_user$data = PdpRespShippingReturns_user;
export type PdpRespShippingReturns_user$key = {
    readonly " $data"?: PdpRespShippingReturns_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespShippingReturns_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespShippingReturns_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyerProtectionBox_user",
      "args": null
    }
  ]
};
(node as any).hash = '33ed795f66f69083fbfb0296e9eaa09b';
export default node;
